export const prefixes = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Ms', label: 'Mrs' },
  { value: 'Prefer not to say', label: 'Prefers not to say' },
];
export const extendedPrefixes = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Ms', label: 'Ms' },
  { value: 'H.E. Mr', label: 'H.E. Mr' },
  { value: 'H.E. Ms', label: 'H.E. Ms' },
  { value: 'H.E. Prof Mr', label: 'H.E. Prof Mr' },
  { value: 'H.E. Prof Ms', label: 'H.E. Prof Ms' },
  { value: 'H.E. Dr Mr', label: 'H.E. Dr Mr' },
  { value: 'H.E. Dr Ms', label: 'H.E. Dr Ms' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof', label: 'Prof' },
  { value: 'Prefer not to say', label: 'Prefers not to say' },
];
export const presences = [
  { value: 'Physically', label: 'I will attend the event physically' },
  { value: 'Virtually', label: 'I will attend the event virtually' },
];
